<template>
  <div>
    <list
      ref="list"
      unit="收入单"
      row-key="DocId"
      light-row
      :page="page"
      @row-select="(x) => $emit('change', x)"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      urlHash="finance/dealings/income"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <!-- <template slot="query">
        <el-form-item label="单位名称">
          <el-input v-model="params.TradeUnitName" placeholder="请填写单位名称"></el-input>
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="票据类型">
          <invoice-select v-model="params.InvoiceTypeId" />
           <el-input v-model="params.IncomeName" placeholder="请填写收入名称"></el-input>
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="业务类型">
          <business-select
            v-model="params.BusinessTypeId"
            :params="{Kind:'应收',SourceType:'收入单'}"
            @change="onChange"
          />
           <el-input v-model="params.IncomeName" placeholder="请填写收入名称"></el-input>
        </el-form-item>
        <el-form-item label="收入名称">
          <el-input v-model="params.IncomeName" placeholder="请填写收入名称"></el-input>
        </el-form-item>
        <el-form-item label="经办人">
          <el-input v-model="params.ClerkName" placeholder="请填写经办人"></el-input>
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="0"></el-option>
            <el-option label="未生效" :value="1"></el-option>
            <el-option label="已生效" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template> -->
      <template slot="table">
        <!-- <el-table-column prop="DocNo" label="单据编号" min-width="150px" show-overflow-tooltip />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="单位名称" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="BusinessType" label="业务类型" />
        <el-table-column prop="InvoiceTypeName" label="票据类型" />
        <el-table-column prop="ClerkName" label="经办人" />
        <el-table-column prop="Amount" label="金额" />
        <el-table-column prop="TaxAmount" label="税额" />
        <el-table-column prop="IncTaxAmount" label="含税金额" />
        <el-table-column prop="ReceiptAmount" label="收款金额" />
        <el-table-column prop="RemainAmount" label="未收金额" />
        <el-table-column prop="Status" label="单据状态" align="center" width="90">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">草稿</el-tag>
            <el-tag type="primary" v-else-if="row.Status==1">未生效</el-tag>
            <el-tag type="success" v-else>已生效</el-tag>
          </template>
        </el-table-column> -->
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/finance/dealings/income/list.json";
import tableParam from "@/data/finance/dealings/income/query.json";
// 后面补充
// import businessSelect from "@/components/basedoc/business/select";
// import invoiceSelect from "@/components/basedoc/invoice/select";

export default {
  mixins: [listMixin],
  components: {
    list,
    // businessSelect,
    // invoiceSelect,
  },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    if (!this.$permission.canPrice("/finance/dealings/income")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(
        (item) => item.tableName == "Amount"
      );
      if (findIndex >= 0) list.tableList.splice(findIndex, 1);
      const findIndex1 = list.tableList.findIndex(
        (item) => item.tableName == "TaxAmount"
      );
      if (findIndex1 >= 0) list.tableList.splice(findIndex1, 1);
      const findIndex2 = list.tableList.findIndex(
        (item) => item.tableName == "IncTaxAmount"
      );
      if (findIndex2 >= 0) list.tableList.splice(findIndex2, 1);
      const findIndex3 = list.tableList.findIndex(
        (item) => item.tableName == "ReceiptAmount"
      );
      if (findIndex3 >= 0) list.tableList.splice(findIndex3, 1);
    }
  },
  data() {
    return {
      api: require("@/api/rp/incomeDoc").default,
      cList: [],
      params: {
        ClerkName: "",
        IncomeName: "",
        TradeUnitName: "",
        DocNo: "",
        BusinessTypeId: null,
        BusinessType: "",
        InvoiceTypeId: null,
        Status: null,
        DocDateStart: "",
        DocDateEnd: "",
      },
      isMB: this.$store.state.isMB,
    };
  },

  methods: {
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map((x) => x.tableName);
          var params = { ...listParams, Fields: fields.join(",") };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.getListExport(params).then((res) => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    onChange(e) {
      console.log("e", e);
      this.params.BusinessType = e.BusinessType;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.$emit("reload");
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
